import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { flexbox, space } from 'styled-system';

import Loader from '@shared/Loader';
import BaseCard from '@styled/Containers/Card';

export default function Card({
  capitalize,
  children,
  helper,
  loading,
  title,
  ...rest
}) {
  return (
    <StyledCard {...rest}>
      {(title || helper) && (
        <CardHeader>
          <Row>
            <CardTitle capitalize={capitalize}>{title}</CardTitle>
            {helper && helper.position !== 'bottom' && (
              <TopRightHelper>
                <SpanOverflow size={helper.size}>{helper.text}</SpanOverflow>
                <span>{helper.action}</span>
              </TopRightHelper>
            )}
          </Row>
          {helper && helper.position === 'bottom' && (
            <Row>
              <BelowTitleHelper>
                <SpanOverflow size={helper.size}>{helper.text}</SpanOverflow>
                <span>{helper.action}</span>
              </BelowTitleHelper>
            </Row>
          )}
        </CardHeader>
      )}
      {children}
      {loading && <Loader />}
    </StyledCard>
  );
}

Card.propTypes = {
  capitalize: PropTypes.bool,
  children: PropTypes.node,
  helper: PropTypes.shape({
    action: PropTypes.node,
    position: PropTypes.oneOf(['bottom']),
    size: PropTypes.string,
    text: PropTypes.node,
  }),
  title: PropTypes.node,
};

const CardHeader = styled.div`
  width: 100%;
  align-items: center;
  margin-bottom: 24px;
`;

export const CardTitle = styled.div`
  color: ${props => props.theme.primary};
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
`;

const TopRightHelper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  font-size: ${props => props.theme.font.fontMd};
`;

const BelowTitleHelper = styled.div`
  margin-top: 6px;
`;

const SpanOverflow = styled.div`
  ${props => props.theme.ellipsis};
  font-size: ${props => (props.size ? props.size : '')};
`;

const Row = styled.div`
  width: 100%;
  display: flex;
`;

const StyledCard = styled(BaseCard)`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-family: ${props => props.theme.font.primary};
  position: relative; /* For the loader */
  width: 100%;
  ${space}
  ${flexbox}
`;

StyledCard.defaultProps = {
  padding: '24px',
};
